import { render, staticRenderFns } from "./TournamentAnnounceModal.vue?vue&type=template&id=4d341ae0&"
import script from "./TournamentAnnounceModal.vue?vue&type=script&lang=js&"
export * from "./TournamentAnnounceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports